import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: 'AIzaSyDtseYtzGRwgSOSN4pmF75Zrhk3hHNQnhY',
  authDomain: 'authentech-9cd3a.firebaseapp.com',
  projectId: 'authentech-9cd3a',
  storageBucket: 'authentech-9cd3a.appspot.com',
  messagingSenderId: '887887244633',
  appId: '1:887887244633:web:bc482cf7495a5060b53048',
}

const app = initializeApp(firebaseConfig)

export default app
